import { useEffect } from 'react';
import { Routes, Route, Link } from "react-router-dom";

import './App.css';
import Mqtt from './js/Mqtt';
import Index from './pages';
import TcfLabor from './pages/tcfLabor';
import TcfWatch from './pages/tcfWatch';
import FallDetection from './pages/fallDetection';
import FallDetectionTwo from './pages/fallDetection2';

function App() {
  const mqttClient = new Mqtt(localStorage);

  // useEffect to avoid connect() on every page load....
  useEffect(() => {
    // load MQTT
    mqttClient.connect();
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="tcflabor" element={<TcfLabor />} />
        <Route path="tcfwatch" element={<TcfWatch />} />
        <Route path="falldetection" element={<FallDetection />} />
        <Route path="falldetectiontwo" element={<FallDetectionTwo />} />
      </Routes>
    </div>
  );
}

export default App;
